import { viewerStrings } from '../copy/strings.js';
import { message, CopyError } from '../copy/text.js';
export type Layout = 'ribbon' | 'rail' | 'console' | 'focus';
export interface Theme {
  version: 1;
  id: number;
  name: string;
  style: string;
  layout: Layout;
  dark: boolean;
  color: string;
  page: string;
  panel: string;
  ink: string;
  muted: string;
  line: string;
  tint: string;
  nav: string;
  navInk: string;
  font: string;
  tableFont: string;
  fontLabel: string;
  tableSize: number;
  headingFont: string;
}

/** Replaced with validated YAML data at build time. No YAML parser ships to the browser. */
declare const __CDR_THEMES__: Theme[];
export const themes: readonly Theme[] = __CDR_THEMES__;

export function getTheme(id: number): Theme {
  const theme = themes.find((candidate) => candidate.id === id);
  if (!theme) throw new CopyError(message(viewerStrings.themesCatalog.unknownTheme, { id: id }));
  return theme;
}

export const layoutLabels: Record<Layout, string> = {
  ribbon: viewerStrings.themesCatalog.fullWidthTabs,
  rail: viewerStrings.themesCatalog.navigationRail,
  console: viewerStrings.themesCatalog.controlBand,
  focus: viewerStrings.themesCatalog.minimalWorkspace,
};
